import React, { Component } from "react";
import Axios from "axios";
import Header from "./Header";
import Navbar from "./Navbar";
import Footer from "./Footer";
import NewConstants from "./NewConstants";

export default class BlogDetails extends Component {
  state = {
    blog: null,
    loading: true,
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    const { id } = this.props.match.params;

    Axios.post(NewConstants.postUrls.blogDetails, { blog_id: id })
      .then((res) => {
        const blogData = res && res.data ? res.data.data : null;
        this.setState({
          blog: blogData || null,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({
          blog: null,
          loading: false,
        });
      });
  }

  render() {
    const { blog, loading } = this.state;

    return (
      <div>
        <Header />
        <Navbar />
        <div className="breadcumb-area bg-img" style={{ position: "relative" }}>
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/7/77/Medlibrary.jpg"
            alt="Students studying together in a busy library reading room."
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              position: "absolute",
              top: 0,
              left: 0,
              zIndex: 0,
            }}
          />
          <div className="bradcumbContent">
            <h2>{blog && blog.title ? blog.title : "Blog Details"}</h2>
          </div>
        </div>

        <section className="blog-area section-padding-100">
          <div className="container">
            {loading ? (
              <div className="text-center">
                <h5>Loading blog...</h5>
              </div>
            ) : blog ? (
              <div className="row justify-content-center">
                <div className="col-12 col-lg-10">
                  <div className="single-blog-post mb-100">
                    {blog.image_path ? (
                      <img
                        src={NewConstants.imageUrl + blog.image_path}
                        alt={blog.img_alt_text || blog.title}
                        style={{ width: "100%", maxHeight: "420px", objectFit: "cover" }}
                      />
                    ) : null}
                    <div className="post-meta" style={{ marginTop: "20px" }}>
                      <p>{blog.meta_description}</p>
                    </div>
                    <div
                      dangerouslySetInnerHTML={{ __html: blog.blog_content || "" }}
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div className="text-center">
                <h5>Blog not found.</h5>
              </div>
            )}
          </div>
        </section>
        <Footer />
      </div>
    );
  }
}
